import React from 'react';
import { Page,PureComponent } from 'core/components';
import { connect } from 'react-redux';
import autobind from 'autobind-decorator';
import { withLocale } from 'core/decorators';
import {TimeTableStep} from 'content/components'

class TimeTablePage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      items: []
    };

    //TODO in meghdar bayad avaz shavad
    // this.props.translator.addModuleResource('timeTable', translations);

  };

  /**
    * handle loading
    * @param {Boolian} loading
    */
  loading(loading = false) {
    this.setState((prevState, props) => {
      return { loading: loading }
    });
  };

  render() {
    return (
      <Page
        pageName="timeTable"
        showBack={true}
        navigate={this.props.navigate}
      >
        <TimeTableStep
          navigate={this.props.navigate}
        />
      </Page>
    );
  };

};


export default connect(
  state => ({
    cart: state.Cart.cart,
    user: state.General.user
  }),
  {

  }
)(withLocale('timeTable')(autobind(TimeTablePage)));